'use client';

function getElementClientRect(element) {
    if (element instanceof Window) {
        var width_1 = window.innerWidth;
        var height_1 = window.innerHeight;
        return {
            width: width_1,
            height: height_1,
            top: 0,
            left: 0,
            bottom: height_1,
            right: width_1,
            x: 0,
            y: height_1
        };
    }
    var _a = element.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height, top = _a.top, bottom = _a.bottom, left = _a.left, right = _a.right;
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}

export { getElementClientRect as default };
//# sourceMappingURL=getElementClientRect.js.map
